import React from 'react'
import PropTypes from 'prop-types'
import { useSmartviewManager, SmartviewBackTrigger } from '@morningtrain/react-smartviews'

import SmartviewHeader from 'widgets/smartviews/partials/SmartviewHeader'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'

function Smartview (props) {
  const smartviewManager = useSmartviewManager()

  React.useEffect(() => {
    smartviewManager.resize(props.size)
  })

  return (
    <div className='smartview-wrapper'>
      <div className='px-8 flex-col'>
        <SmartviewHeader>
          {props.header}
        </SmartviewHeader>
      </div>
      <div className='px-8 flex-col flex-wrap'>
        {props.children}
      </div>
      <div className='px-8 flex-col'>
        {props.footer}
      </div>
      <SmartviewBackTrigger>
        <div className='px-8'>
          <SmartviewContentSeparator />
          <button className='btn btn-primary btn-full'>GO BACK</button>
        </div>
      </SmartviewBackTrigger>
    </div>
  )
}

Smartview.defaultProps = {
  size: 'xs',
  header: null,
  footer: null
}

Smartview.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', '4xl', '5xl', '6xl', 'full']),
  header: PropTypes.node,
  footer: PropTypes.node
}

export default Smartview
